import React, { useEffect, useState } from "react";
import { CiSearch } from "react-icons/ci";
import {
  CategoriesGroupscard1,
  fill_heart,
  heart_icon,
  lock_icon,
  subscription_icon,
} from "../../../../assets";
import { GoDotFill } from "react-icons/go";
import { Link, useNavigate } from "react-router-dom";
import { IoMdArrowBack } from "react-icons/io";
import { groupListingApi } from "../../../../services/groups";
import InfiniteScroll from "react-infinite-scroll-component";
import { GroupCardSkeleton } from "../../../../shimmer/groups/GroupsListingShimmer";
import { updateFavoriteListHandler } from "../groupSubModules/LikeUnlikeHeart";

const CreatedGroup = ({ groupType, memberId }) => {
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [groupList, setGroupList] = useState([]);
  const [total, setTotal] = useState(null);
  const navigate = useNavigate();
  const fetchingGroupListHandler = async (page = 1, isRefresh = false) => {
    try {
      //   setShowShimmer(true);
      const { data } = await groupListingApi({
        type: groupType === "joined" ? "joined" : "",
        pagination: "true",
        limit: 10,
        page: page,
        _user: memberId,
        limit: 10,
      });
      const { data: groupList, success, message, meta } = data;
      // if (success) {
      //   // setGroupList(groupList);
      //   setTotal(meta?.totalRecords);
      //   setPage(meta?.page);
      //   if (reset) {
      //     setGroupList(groupList || []);
      //   } else {
      //     setGroupList((prev) => [...prev, ...(groupList || [])]);
      //   }
      // }
      if (success) {
        if (isRefresh) {
          setGroupList(groupList || []);
        } else {
          setGroupList((prev) => [...prev, ...(groupList || [])]);
        }
        setHasMore(groupList.length === 10);
      }
    } catch (e) {
      console.log("Error:-", e.message);
    } finally {
      //   setShowShimmer(false);
    }
  };

  useEffect(() => {
    setPage(1);
    setHasMore(true);
    fetchingGroupListHandler(1, true);
  }, [memberId]);

  const fetchMoreData = () => {
    setPage((prevPage) => {
      const nextPage = prevPage + 1;
      fetchingGroupListHandler(nextPage);
      return nextPage;
    });
  };

  // useEffect(() => {
  //   if (memberId) {
  //     fetchingGroupListHandler();
  //   }
  // }, []);

  // useEffect(() => {
  //   if (page > 1) {
  //     fetchingGroupListHandler(false);
  //   }
  // }, [page]);

  //--------navigate-details-page--------------
  const navigateDetailsPage = (id) => {
    navigate(`/dashboard/group/detail/${id}`);
  };
  return (
    <div className="CategoriesGroupsList_parent">
      {/* <div className="CategoriesGroupsList_cards">
        <div className="health_hub_cards">
          {groupList?.map((data, ind) => (
            <div key={ind} className="health_hub_img">
              <Link to={`/dashboard/group/detail/${data?._group?._id}`}></Link>

              <div className="image_containerss">
                <img src={data?._group?.coverImage} />
                <div className="health_hub_img_text">
                  <h6>{data?._group?.name}</h6>
                  <p>
                    <GoDotFill className="live_dot" /> 1 New Post
                  </p>
                </div>
              </div>

              <div className="health_hub_containt">
                <span>{data?._group?.categoryName}</span>

                <figure className="health_hub_icons">
                  {data?.type === "PRIVATE" && (
                    <img src={lock_icon} className="lockimg" />
                  )}
                  <img src={heart_icon} className="heartimg" />
                </figure>
              </div>
            </div>
          ))}
        </div>
      </div> */}

      <div id="scrollableContainer" className="CategoriesGroupsList_cards">
        <InfiniteScroll
          dataLength={groupList.length}
          next={fetchMoreData}
          hasMore={hasMore}
          loader={<GroupCardSkeleton count={5} />}
          // endMessage={
          //   <p style={{ textAlign: "center", margin: "25px" }}>
          //     <b>No more data to display</b>
          //   </p>
          // }
          scrollableTarget="scrollableContainer"
        >
          <div className="health_hub_cards">
            {groupList && groupList.length > 0
              ? groupList?.map((data, ind) => (
                  <div key={ind} className="health_hub_img">
                    <div
                      onClick={() => navigateDetailsPage(data?._group?._id)}
                      className="image_containerss pointer-cursor"
                    >
                      <img src={data?._group?.coverImage} />
                      <div className="health_hub_img_text">
                        <h6>{data?._group?.name}</h6>
                        <p>
                          {data?._group?.newFeeds?.count > 0 ? (
                            <>
                              <GoDotFill className="live_dot" />
                              {`${data?._group?.newFeeds?.count} New Post${
                                data?._group?.newFeeds?.count > 1 ? "s" : ""
                              }`}
                            </>
                          ) : null}
                        </p>
                      </div>
                    </div>

                    <div className="health_hub_containt">
                      <span className="tag dark">{data?._group?.categoryName}</span>

                      <figure className="health_hub_icons">
                        {data?._group?.type === "SUBSCRIPTION" && (
                          <img src={subscription_icon} className="lockimg" />
                        )}
                        {data?._group?.type === "PRIVATE" && (
                          <img src={lock_icon} className="lockimg" />
                        )}
                        <img
                          src={
                            data?.favoriteGroup?.status === "ACTIVE"
                              ? fill_heart
                              : heart_icon
                          }
                          className="heartimg"
                          onClick={() =>
                            updateFavoriteListHandler(
                              data?._group?._id,
                              setGroupList,
                              data?.favoriteGroup?.status === "ACTIVE"
                                ? "INACTIVE"
                                : "ACTIVE"
                            )
                          }
                        />
                      </figure>
                    </div>
                  </div>
                ))
              : null}
          </div>
        </InfiniteScroll>
      </div>
    </div>
  );
};

export default CreatedGroup;
